import { AberrationsService } from './services/aberrations.service';
import { AberrationsActionCreatorService } from './services/aberrations-action-creator.service';
import { ManualCurationService } from './services/manual-curation.service';
import { AberrationsMetaActionCreatorService } from './services/aberrations-meta-action-creator.service';
import { AberrationInfoService } from '../test/components/aberration-info-service/aberration-info.service';

export const ABERRATION_SERVICES = [
  AberrationsService,
  AberrationsActionCreatorService,
  AberrationsMetaActionCreatorService,
  AberrationInfoService,
  ManualCurationService
];
export const ABERRATION_COMPONENTS = [];
